/* Hook encargado de hacer la consulta a la base y 
traer  el contenido de los datos aceptados por Mercado Libre

Autor: Benjamín León
Fecha: 2025-03-23
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'

import { makeUrlMeliDirectCategoryAttr, makeUrlMeliLogged, makeUrlMeliTypes } from './connectionData.tsx'

interface CategoryAttr {
  brands: string[]
  colors: string[]
  fuel: string[]
  gearbox: string[]
  bodies: string[]
}
const useMeliFetcher = () => {
  const [errorMeliCategoryAttr, setErrorMeliCategoryAttr] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [errorMeliTypes, setErrorMeliTypes] = useState<Error | null>(null)
  const [errorMeliLogged, setErrorMeliLogged] = useState<Error | null>(null)

  const meliCategoryAttr = async () => {
    setLoading(true)

    try {
      // This endpoint now requires authentication
      const apiUrl = makeUrlMeliDirectCategoryAttr()

      // Use customFetch to include the authentication token
      const data = await customFetch<CategoryAttr>(apiUrl)

      setErrorMeliCategoryAttr(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliCategoryAttr(err)
      } else {
        setErrorMeliCategoryAttr(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  const meliTypes = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliTypes()
      const data = await customFetch<Record<string, string>>(apiUrl)

      setErrorMeliTypes(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliTypes(err)
      } else {
        setErrorMeliTypes(new Error('An unknown error occurred'))
      }

      return {}
    } finally {
      setLoading(false)
    }
  }

  // Este indica si estamos logeados en mercado libre
  const meliLogged = async (profile: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMeliLogged(profile)
      const data = await customFetch<{ loggedState: number }>(apiUrl)
      setErrorMeliLogged(null)

      return data.loggedState
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMeliLogged(err)
      } else {
        setErrorMeliLogged(new Error('An unknown error occurred'))
      }

      return false
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    meliTypes,
    meliCategoryAttr,
    meliLogged,
    errorMeliTypes,
    errorMeliCategoryAttr,
    errorMeliLogged,
  }
}

export default useMeliFetcher
